import React from 'react';
import { cx } from './cx';

export const iconNames = ['close', 'arrow-up', 'arrow-down', 'check', 'search'] as const;

export type IconName = (typeof iconNames)[number];

const geometry: Record<IconName, string> = {
  close: 'M4 4 L12 12 M12 4 L4 12',
  'arrow-up': 'M8 13 V4 M4 8 L8 4 L12 8',
  'arrow-down': 'M8 3 V12 M4 8 L8 12 L12 8',
  check: 'M3 8 L7 12 L13 4',
  search: 'M7 3 A4 4 0 1 0 7 11 A4 4 0 1 0 7 3 M10 10 L14 14',
};

interface IconProps {
  name: IconName;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, className }) => {
  return (
    <svg className={cx('osrs-icon', className)} viewBox="0 0 16 16" aria-hidden="true">
      <path d={geometry[name]} />
    </svg>
  );
};

export default Icon;
